import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    :host {
      --gala-between-row-padding: calc(30rem / var(--default-rem-px-count));
      --gala-between-column-padding: calc(24rem / var(--default-rem-px-count));
      --gala-details-padding: calc(40rem / var(--default-rem-px-count));
    }

    .gala-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
      background-color: #f8f8f8;
    }

    .driver-image {
      grid-column: 1 / 9;
      grid-row: 4;
    }

    .eyebrow {
      grid-column: 2 / 8;
      grid-row: 2;
    }

    h1 {
      grid-column: 2 / 8;
      grid-row: 3;
    }

    .description {
      grid-column: 2 / 8;
      grid-row: 5;
    }

    cta-button {
      grid-column: 2 / 8;
      grid-row: 6;
    }

    /* Old rule had line-height smaller than font-size; caption tokens
       restore a sane ratio. */
    .eyebrow {
      align-self: end;
      color: #315470;
      font-size: var(--fs-caption);
      line-height: var(--lh-caption);
      letter-spacing: var(--ls-caption);
    }

    .description {
      margin-bottom: calc(20rem / var(--default-rem-px-count));
    }

    img {
      width: 100%;
    }

    @media (min-width: 600px) {
      :host {
        --gala-between-row-padding: calc(40rem / var(--default-rem-px-count));
        --gala-between-column-padding: calc(
          32rem / var(--default-rem-px-count)
        );
      }

      .driver-image {
        grid-column: 1 / 15;
        grid-row: 4;
        margin-bottom: calc(20rem / var(--default-rem-px-count));
      }

      .eyebrow {
        grid-column: 2 / 14;
        grid-row: 2;
        margin-bottom: calc(10rem / var(--default-rem-px-count));
        margin-left: var(--gala-details-padding);
      }

      h1 {
        grid-column: 2 / 14;
        grid-row: 3;
        margin-bottom: calc(20rem / var(--default-rem-px-count));
        margin-left: var(--gala-details-padding);
      }

      .description {
        grid-column: 2 / 14;
        grid-row: 5;
        margin-left: var(--gala-details-padding);
        margin-right: var(--gala-details-padding);
      }

      cta-button {
        grid-column: 2 / 14;
        grid-row: 6;
        margin-left: var(--gala-details-padding);
        padding-top: var(--gala-details-padding);
      }
    }

    @media (min-width: 1024px) {
      :host {
        --gala-between-row-padding: calc(80rem / var(--default-rem-px-count));
        --gala-between-column-padding: calc(
          32rem / var(--default-rem-px-count)
        );
      }

      .gala-layout {
        grid-template-rows: 1fr auto auto 1fr;
        background-color: #f8f8f8;
      }

      .driver-image {
        grid-column: 6 / 15;
        grid-row: 1 / 5;
        margin-bottom: 0;
      }

      .eyebrow {
        grid-column: 2 / 6;
        grid-row: 1;
      }

      h1 {
        grid-column: 2 / 6;
        grid-row: 2;
      }

      .description {
        grid-column: 2 / 6;
        grid-row: 3;
      }

      cta-button {
        grid-column: 2 / 6;
        grid-row: 4;
      }
    }
  `,
];
